import React, { useState } from "react";
import {
  checkCurrentLanguageSelected,
  jsonApiHeader,
  checkHttpStatus,
} from "../src/Shared/utility";
import { useSelector } from "react-redux";
import { getStoreId } from "../src/Shared/AppContext/selectors/index";
import { useEffect } from "react";

const UserContext = React.createContext();

const UserProvider = ({ children }) => {
  const storeId = useSelector(getStoreId);

  const [selectedLanguage, setSelectedLanguage] = useState("EN");
  const [cartItemsQty, setCartItemsQty] = useState("");
  const [cartItemsData, setCartItemsData] = useState(null);
  const [orderId, setOrderId] = useState(null);

  async function getCartItemsCount(storeId) {
    const response = await fetch(`/wcs/resources/store/${storeId}/cart/@self`, {
      method: "GET",
      headers: jsonApiHeader(),
    });
    const data = await checkHttpStatus(response);
    if (data) {
      const orderItem = data.orderItem;

      setCartItemsData(data);
      setOrderId(data.orderId);
      var qtyCount = 0;
      Array.isArray(orderItem) &&
        orderItem.length &&
        orderItem.forEach((item) => {
          qtyCount += parseInt(item.quantity);
        });
      setCartItemsQty(qtyCount);
      return data;
    }
  }

  useEffect(() => {
    async function fetchLanguage() {
      const data = await checkCurrentLanguageSelected(storeId);
      setSelectedLanguage(data);
    }
    fetchLanguage();
    getCartItemsCount(storeId);
  }, [storeId]);

  const setLanguage = (language) => {
    setSelectedLanguage(language);
  };

  return (
    <UserContext.Provider
      value={{
        selectedLanguage,
        setLanguage,
        cartItemsQty,
        getCartItemsCount,
        cartItemsData,
        orderId,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export { UserProvider, UserContext };

export const UserConsumer = UserContext.Consumer;
